import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/_following.scss";

export const Following = (): React.ReactElement => {
  const [hidden, setHidden] = useState(false);
  const isSP = window.innerWidth < 750;
  return (
    <div className={`following ${hidden ? "hidden" : ""}`}>
      <Link to="/lp">
        {isSP ? (
          <img src="../images/following-sp.png" alt="" className="bnr" />
        ) : (
          <img src="../images/following.png" alt="" className="bnr" />
        )}
      </Link>
      <img
        src="../images/following-close_icon.png"
        alt=""
        className="icon"
        onClick={() => setHidden(true)}
      />
    </div>
  );
};
